import {Component, createRef} from 'react';
import {Button} from "reactstrap"
import Draggable from 'react-draggable';
import '../../css/styles.css';
import termDictionary from './Datasets/term_dictionary';

class DictionaryModal extends Component {
            constructor(props) {
              super(props);
              this.state={
                    termDictionary: termDictionary,
              }
        this.nodeRef = createRef(); 
        this.getTermDefinition();    
    }

    getTermDefinition(){
        let termName = this.props.termName.toLowerCase();
        this.termDefinitionObj = this.state.termDictionary.find(elem => elem.termName === termName);
        if (!this.termDefinitionObj){
            this.termDefinitionObj = this.state.termDictionary.find(elem => elem.altName === termName);
        }
        if (!this.termDefinitionObj){
                this.termDefinition = "Oops!! This term is not found in the dictionary.  Please add a comment " +
                "to note that the term is missing from the dictionary.  Thank you!!!";
        }else{
                this.termDefinition = this.termDefinitionObj.termDefinition;
        }
    }
        
    render() {

    return <>
        <div className="modal-overlay"></div>
            <Draggable handle=".modal-header" nodeRef={this.nodeRef}>
                <div className="custom-modal" ref={this.nodeRef}>
                <div className = "modal-header backgroundTopBottom">
                    <h4>
                            Definition of Term: &nbsp;{this.props.termName}
                    </h4>
                    <img src="./assets/sidebar_icon.png" className="train_icon_thumbnail_small_img"
                        alt="trainIcon"/>
                </div>
                <div className="modal-body">
                    <div className="my-2">
                            {this.termDefinition}
                    </div>
                    
                </div>
                <div className="modal-footer p-0 backgroundTopBottom d-flex 
                    justify-content-between align-items-center">
                        <div>
                                <b> Note:</b>  You can drag this box up, down, right, or left.
                        </div>
                        <div>
                            <Button variant="primary"  className="mr-4" onClick={() => this.props.onClose()}
                                    onTouchEnd={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.props.onClose();
                                    }} >
                                Close
                            </Button>
                        </div>
                </div>
            </div>
        </Draggable>
        </>
    }


}

export default DictionaryModal;